import { Module } from 'vuex';

import authenticationModule from '../../modules/AuthenticationPage/store';
import verificationModule from '../../modules/VerificationPage/store';

import sharedActions from './shared.actions';
import sharedMutations from './shared.mutations';
import sharedGetters from './shared.getters';
import { DEFAULT_DIRECTION, DEFAULT_LOCALE } from './constants';
import { ILoginStore } from './shared.types';

const loginModule: Module<ILoginStore, any> = {
  namespaced: true,

  state: {
    direction: DEFAULT_DIRECTION,
    locale: DEFAULT_LOCALE,
    metaInfo: null,
    organization: null,
    documents: {},
  },
  mutations: sharedMutations,
  actions: sharedActions,
  getters: sharedGetters,
  modules: {
    verificationModule,
    authenticationModule,
  },
};

export default loginModule;
